<template>
    <div>
      <div class="dash-heading"><i class="fa fa-globe" />&nbsp;General Summary</div><br />

      <el-tabs>


        <el-tab-pane v-if="!isProjectView()">
          <template #label><span><i class="fa fa-chart-pie"></i> Sites &amp; Operations</span></template>

          <el-row>
            <div class="dash-heading">Sites</div>
            <el-col :xs="24":sm="14" :md="16" :lg="12">
              <sites-chart :show-legend="false" :stats="stats" />
            </el-col>

            <el-col :xs="24" :sm="10" :md="8" :lg="8">
              <sites-stats-table :stats="stats" />
            </el-col>
          </el-row>

          <div v-if="canAccess('project|maintenance|management|admin') && stats.actions && stats.tickets && !isProjectView()">
            <el-row>
              <div class="dash-heading">Operations</div>
            </el-row>

          <el-row>
            <el-col :span="24">
              <op-stats :stats="stats" />
            </el-col>
          </el-row>


          </div>

        </el-tab-pane>



        <el-tab-pane  v-if="isTowerCo() && canAccess('management|project|maintenance|finance|admin')"  lazy>
          <template #label><span><i class="fa fa-users"></i> Sharer Summary</span></template>

            <el-row>
              <div class="dash-heading">Sharers</div>
            </el-row>

            <sharer-report :show-ways="true" />

        </el-tab-pane>




        <el-tab-pane v-if="isTelco() || canAccess('project|finance|maintenance|admin')" lazy>
          <template #label><span><i class="fa fa-download"></i> Request Files</span></template>

          <el-row>
            <div class="dash-heading">Request Files</div>
          </el-row>

          <files-request-table  />
        </el-tab-pane>


      </el-tabs>

    </div>
</template>


<script>

import NumberMixins from '@/mixins/NumberMixins'

import OpStats from '@/components/dashboard/OpStats'
import FilesRequestTable from '@/components/tables/FilesRequestTable'

import SitesChart from '@/components/dashboard/charts/SitesChart'
import SitesStatsTable from '@/components/dashboard/sites/SitesStatsTable'

import SharerReport from '@/components/dashboard/sharers/SharerReport'

export default {
  mixins: [NumberMixins],

  components: {
    FilesRequestTable,
    SharerReport,
    SitesChart,
    SitesStatsTable,
    OpStats
  },

  data () {
    return {
      stats: this.getStats()
    }
  },

  computed: {
    clientLogo () {
      const path = this.xolasClient().logoPath
      return path ? this.getStore().hostname + path : null
    }
  },

  created () {

    if (!this.stats) {
      this.refreshStats()
    }
  }

}
</script>
